// Master Legal Subjects & Practice Areas
// Used across ALL tools for consistent filtering and categorization

export const PRACTICE_AREAS = [
  // Personal Injury & Torts
  { value: "personal_injury", label: "Personal Injury", category: "torts" },
  { value: "auto_accident", label: "Auto Accident", category: "torts" },
  { value: "slip_and_fall", label: "Slip & Fall / Premises Liability", category: "torts" },
  { value: "medical_malpractice", label: "Medical Malpractice", category: "torts" },
  { value: "product_liability", label: "Product Liability", category: "torts" },
  { value: "wrongful_death", label: "Wrongful Death", category: "torts" },
  { value: "nursing_home_abuse", label: "Nursing Home Abuse", category: "torts" },
  { value: "dog_bite", label: "Dog Bite / Animal Attack", category: "torts" },
  { value: "toxic_tort", label: "Toxic Tort / Environmental", category: "torts" },
  { value: "mass_tort", label: "Mass Tort / Class Action", category: "torts" },

  // Insurance
  { value: "insurance_defense", label: "Insurance Defense", category: "insurance" },
  { value: "insurance_bad_faith", label: "Insurance Bad Faith", category: "insurance" },
  { value: "coverage_disputes", label: "Coverage Disputes", category: "insurance" },
  { value: "subrogation", label: "Subrogation", category: "insurance" },
  { value: "first_party_claims", label: "First Party Claims", category: "insurance" },
  { value: "third_party_claims", label: "Third Party Claims", category: "insurance" },
  { value: "um_uim", label: "UM/UIM Claims", category: "insurance" },
  { value: "property_insurance", label: "Property Insurance", category: "insurance" },
  { value: "life_insurance", label: "Life & Disability Insurance", category: "insurance" },
  { value: "health_insurance", label: "Health Insurance Disputes", category: "insurance" },
  { value: "workers_comp_insurance", label: "Workers' Comp Insurance", category: "insurance" },
  { value: "professional_liability", label: "Professional Liability / E&O", category: "insurance" },
  { value: "reinsurance", label: "Reinsurance", category: "insurance" },

  // Employment & Labor
  { value: "employment_discrimination", label: "Employment Discrimination", category: "employment" },
  { value: "wrongful_termination", label: "Wrongful Termination", category: "employment" },
  { value: "wage_hour", label: "Wage & Hour", category: "employment" },
  { value: "harassment", label: "Harassment / Hostile Work Environment", category: "employment" },
  { value: "workers_compensation", label: "Workers' Compensation", category: "employment" },
  { value: "ada_accommodations", label: "ADA / Accommodations", category: "employment" },
  { value: "fmla", label: "FMLA / Leave Issues", category: "employment" },
  { value: "non_compete", label: "Non-Compete / Trade Secrets", category: "employment" },
  { value: "osha", label: "OSHA / Workplace Safety", category: "employment" },

  // Business & Commercial
  { value: "contract_dispute", label: "Contract Dispute", category: "business" },
  { value: "business_litigation", label: "Business Litigation", category: "business" },
  { value: "partnership_dispute", label: "Partnership Dispute", category: "business" },
  { value: "fraud", label: "Fraud / Misrepresentation", category: "business" },
  { value: "breach_fiduciary", label: "Breach of Fiduciary Duty", category: "business" },
  { value: "unfair_business", label: "Unfair Business Practices", category: "business" },
  { value: "antitrust", label: "Antitrust / Competition", category: "business" },
  { value: "securities", label: "Securities Litigation", category: "business" },
  { value: "shareholder_dispute", label: "Shareholder Disputes", category: "business" },
  { value: "construction_defect", label: "Construction Defect", category: "business" },

  // Family Law
  { value: "divorce", label: "Divorce / Dissolution", category: "family" },
  { value: "child_custody", label: "Child Custody", category: "family" },
  { value: "child_support", label: "Child Support", category: "family" },
  { value: "domestic_violence", label: "Domestic Violence", category: "family" },
  { value: "adoption", label: "Adoption", category: "family" },
  { value: "paternity", label: "Paternity", category: "family" },
  { value: "guardianship", label: "Guardianship / Conservatorship", category: "family" },

  // Criminal Law
  { value: "criminal_defense", label: "Criminal Defense", category: "criminal" },
  { value: "dui_dwi", label: "DUI / DWI", category: "criminal" },
  { value: "white_collar_crime", label: "White Collar Crime", category: "criminal" },
  { value: "drug_offense", label: "Drug Offenses", category: "criminal" },
  { value: "juvenile", label: "Juvenile Law", category: "criminal" },
  { value: "federal_crime", label: "Federal Crimes", category: "criminal" },

  // Real Estate & Property
  { value: "real_estate", label: "Real Estate Transactions", category: "property" },
  { value: "landlord_tenant", label: "Landlord / Tenant", category: "property" },
  { value: "property_dispute", label: "Property Disputes", category: "property" },
  { value: "foreclosure", label: "Foreclosure Defense", category: "property" },
  { value: "eminent_domain", label: "Eminent Domain", category: "property" },
  { value: "zoning", label: "Zoning / Land Use", category: "property" },

  // Intellectual Property
  { value: "patent", label: "Patent", category: "ip" },
  { value: "trademark", label: "Trademark", category: "ip" },
  { value: "copyright", label: "Copyright", category: "ip" },
  { value: "trade_secret", label: "Trade Secret", category: "ip" },
  { value: "ip_licensing", label: "IP Licensing", category: "ip" },

  // Government & Administrative
  { value: "administrative_law", label: "Administrative Law", category: "government" },
  { value: "government_contracts", label: "Government Contracts", category: "government" },
  { value: "environmental", label: "Environmental Law", category: "government" },
  { value: "immigration", label: "Immigration", category: "government" },
  { value: "tax_law", label: "Tax Law", category: "government" },
  { value: "veterans", label: "Veterans' Benefits", category: "government" },

  // Estate & Probate
  { value: "estate_planning", label: "Estate Planning", category: "estate" },
  { value: "probate", label: "Probate / Administration", category: "estate" },
  { value: "trust_litigation", label: "Trust Litigation", category: "estate" },
  { value: "elder_law", label: "Elder Law", category: "estate" },

  // Healthcare
  { value: "healthcare_compliance", label: "Healthcare Compliance", category: "healthcare" },
  { value: "hipaa", label: "HIPAA Violations", category: "healthcare" },
  { value: "medicare_medicaid", label: "Medicare / Medicaid", category: "healthcare" },
  { value: "pharmaceutical", label: "Pharmaceutical Litigation", category: "healthcare" },

  // Other
  { value: "bankruptcy", label: "Bankruptcy", category: "other" },
  { value: "consumer_protection", label: "Consumer Protection", category: "other" },
  { value: "civil_rights", label: "Civil Rights", category: "other" },
  { value: "education_law", label: "Education Law", category: "other" },
  { value: "maritime", label: "Maritime / Admiralty", category: "other" },
  { value: "appellate", label: "Appellate Practice", category: "other" },
  { value: "arbitration_mediation", label: "Arbitration & Mediation", category: "other" },
  { value: "other", label: "Other", category: "other" },
];

export const PRACTICE_CATEGORIES = [
  { value: "torts", label: "Personal Injury & Torts", icon: "Scale" },
  { value: "insurance", label: "Insurance", icon: "Shield" },
  { value: "employment", label: "Employment & Labor", icon: "Briefcase" },
  { value: "business", label: "Business & Commercial", icon: "Building2" },
  { value: "family", label: "Family Law", icon: "Users" },
  { value: "criminal", label: "Criminal Law", icon: "Gavel" },
  { value: "property", label: "Real Estate & Property", icon: "Home" },
  { value: "ip", label: "Intellectual Property", icon: "FileCheck" },
  { value: "government", label: "Government & Administrative", icon: "Landmark" },
  { value: "estate", label: "Estate & Probate", icon: "FileText" },
  { value: "healthcare", label: "Healthcare", icon: "Heart" },
  { value: "other", label: "Other Specialties", icon: "MoreHorizontal" },
];

// Insurance sub-specialties for dedicated insurance section
export const INSURANCE_SPECIALTIES = [
  { value: "auto_insurance", label: "Auto Insurance", desc: "PIP, collision, liability coverage" },
  { value: "homeowners", label: "Homeowners Insurance", desc: "Property damage, liability, additional living expenses" },
  { value: "commercial_general", label: "Commercial General Liability", desc: "CGL policies, occurrence vs claims-made" },
  { value: "professional_liability", label: "Professional Liability (E&O)", desc: "Errors & omissions, malpractice" },
  { value: "directors_officers", label: "Directors & Officers (D&O)", desc: "Corporate officer liability" },
  { value: "umbrella_excess", label: "Umbrella / Excess Liability", desc: "Excess coverage, drop-down provisions" },
  { value: "workers_comp", label: "Workers' Compensation", desc: "Employer liability, subrogation" },
  { value: "life_disability", label: "Life & Disability", desc: "ERISA, individual and group policies" },
  { value: "health", label: "Health Insurance", desc: "Coverage denial, network disputes, prior auth" },
  { value: "bad_faith", label: "Bad Faith", desc: "Unreasonable denial, delay, inadequate investigation" },
  { value: "subrogation", label: "Subrogation", desc: "Recovery actions, lien negotiation" },
  { value: "reinsurance", label: "Reinsurance", desc: "Treaty disputes, facultative coverage" },
  { value: "surety_bond", label: "Surety & Bond", desc: "Performance bonds, payment bonds" },
  { value: "cyber_insurance", label: "Cyber Insurance", desc: "Data breach, ransomware, business interruption" },
  { value: "marine_cargo", label: "Marine / Cargo", desc: "Hull insurance, cargo loss, P&I" },
];

// AI Verification statuses
export const VERIFICATION_STATUSES = {
  PENDING: "pending_review",
  AI_GENERATED: "ai_generated",
  UNDER_REVIEW: "under_review",
  APPROVED: "approved",
  REJECTED: "rejected",
  REVISION_REQUESTED: "revision_requested",
};

export const VERIFICATION_STATUS_CONFIG = {
  pending_review: { label: "Pending Review", color: "bg-yellow-100 text-yellow-800", icon: "Clock" },
  ai_generated: { label: "AI Generated", color: "bg-blue-100 text-blue-800", icon: "Cpu" },
  under_review: { label: "Under Review", color: "bg-purple-100 text-purple-800", icon: "Eye" },
  approved: { label: "Approved", color: "bg-green-100 text-green-800", icon: "CheckCircle2" },
  rejected: { label: "Rejected", color: "bg-red-100 text-red-800", icon: "XCircle" },
  revision_requested: { label: "Revision Requested", color: "bg-orange-100 text-orange-800", icon: "RotateCcw" },
};

// Confidence levels for AI outputs
export const CONFIDENCE_LEVELS = [
  { min: 0, max: 40, label: "Low Confidence", color: "text-red-600", desc: "Requires manual review" },
  { min: 41, max: 70, label: "Moderate Confidence", color: "text-yellow-600", desc: "Review recommended" },
  { min: 71, max: 90, label: "High Confidence", color: "text-blue-600", desc: "Standard review" },
  { min: 91, max: 100, label: "Very High Confidence", color: "text-green-600", desc: "Quick verification" },
];

// Helper: Get practice areas by category
export const getPracticeAreasByCategory = (category) => {
  return PRACTICE_AREAS.filter(pa => pa.category === category);
};

// Helper: Get all categories with their areas
export const getCategorizedPracticeAreas = () => {
  return PRACTICE_CATEGORIES.map(cat => ({
    ...cat,
    areas: PRACTICE_AREAS.filter(pa => pa.category === cat.value),
  }));
};

// Helper: Get confidence level for a score
export const getConfidenceLevel = (score) => {
  return CONFIDENCE_LEVELS.find(l => score >= l.min && score <= l.max) || CONFIDENCE_LEVELS[0];
};
